// extracted by mini-css-extract-plugin
export default {"root":"styles_root__1tCTV","modalContainer":"styles_modalContainer__z9uM4","title":"styles_title__Q2IBu","closeBtn":"styles_closeBtn__yX8RY"};